/**
 * @generated SignedSource<<49c63ef7df62e87b192e2d7b347625ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateClassInput = {
  gradeIds: ReadonlyArray<string>;
  isActive?: boolean | null | undefined;
  isJoinCodeActive?: boolean | null | undefined;
  name: string;
  ownerId: string;
  section: string;
  siteId: string;
};
export type ClassesCreateClassMutation$variables = {
  input: CreateClassInput;
};
export type ClassesCreateClassMutation$data = {
  readonly createClass: {
    readonly classNode: {
      readonly gradeLevels: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly id: string;
      readonly isActive: boolean;
      readonly name: string | null | undefined;
      readonly owner: {
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
      } | null | undefined;
      readonly section: string | null | undefined;
      readonly site: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly users: ReadonlyArray<{
        readonly classes: ReadonlyArray<{
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly firstName: string | null | undefined;
        readonly gradeLevels: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly id: string;
        readonly isActive: boolean;
        readonly lastName: string | null | undefined;
        readonly roles: ReadonlyArray<{
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly sites: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
  };
};
export type ClassesCreateClassMutation = {
  response: ClassesCreateClassMutation$data;
  variables: ClassesCreateClassMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "section",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "GradeLevelNode",
  "kind": "LinkedField",
  "name": "gradeLevels",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "site",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v12 = [
  (v3/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "sites",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "type": "Error",
      "abstractKey": "__isError"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesCreateClassMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateClassPayload",
        "kind": "LinkedField",
        "name": "createClass",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "classNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassesCreateClassMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateClassPayload",
        "kind": "LinkedField",
        "name": "createClass",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "classNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8be9e7c7ea1b822e997095115cefa659",
    "id": null,
    "metadata": {},
    "name": "ClassesCreateClassMutation",
    "operationKind": "mutation",
    "text": "mutation ClassesCreateClassMutation(\n  $input: CreateClassInput!\n) {\n  createClass(input: $input) {\n    classNode {\n      id\n      name\n      section\n      gradeLevels {\n        name\n        id\n      }\n      site {\n        id\n        name\n      }\n      isActive\n      users {\n        id\n        firstName\n        lastName\n        isActive\n        roles {\n          name\n          id\n        }\n        sites {\n          id\n          name\n        }\n        classes {\n          name\n          id\n        }\n        gradeLevels {\n          name\n          id\n        }\n      }\n      owner {\n        id\n        firstName\n        lastName\n      }\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1f250e56ef3dd1898671b67db6bcce03";

export default node;
